import foldingUmbrella from "@/assets/images/2fold.png";
import foldingUmbrella1 from "@/assets/images/2fold1.png";
import foldingUmbrella2 from "@/assets/images/2fold2.jpg";
import gardenUmbrella from "@/assets/images/GardenUmbrella.png";
import garden from "@/assets/images/garden.jpg";
import garden1 from "@/assets/images/garden1.png";
import longUmbrella from "@/assets/images/longUmbrellas.png";
import long from "@/assets/images/long.png";
import long1 from "@/assets/images/long1.png";
import long2 from "@/assets/images/long2.png";
import golfUmbrella from "@/assets/images/golfUmbrellas.png";
import golf from "@/assets/images/golf.png";
import golf1 from "@/assets/images/golf1.png";
import golf2 from "@/assets/images/golf2.png";
import kiosk from "@/assets/images/kiosk.jpeg";
import gazebos from "@/assets/images/gazebos.png";
import gazebo1 from "@/assets/images/gazebo1.png";
import gazebo2 from "@/assets/images/gazebo2.png";
import kids from "@/assets/images/kids.png";
import kids1 from "@/assets/images/kids1.jpeg";
import kids2 from "@/assets/images/kids2.png";
import logo from "@/assets/images/Logo1.jpg";
import hangyo from "@/assets/images/Hangyo.png";
import bsnl from "@/assets/images/BSNL.png";
import bigbasket from "@/assets/images/bigBasket.png";
import adani from "@/assets/images/adani.png";
import manipal from "@/assets/images/Manipal.jpg";
import suzuki from "@/assets/images/Maruti-Suzuki.png";
import ramco from "@/assets/images/ramcocements.png";
import bob from "@/assets/images/bob.jpg";
import headerLogo from "@/assets/images/headerLogo.png";

export const companyInfo = {
  name: "Keshavlal & Company",
  tagline: "Umbrella Manufacturers Since 1946",
  headerLogo,
  phoneDisplay: "+91 9591415859",
  phoneLink: "+919591415859",
  email: "keshavlal.umbrellas@outlook.com",
  address: "Naufal Building, Mission St, Bhavathi, Bunder, Mangaluru, Karnataka-575001",
  mapLink: "https://share.google/WpjGPkUQPDkgSkBBV",
  whatsappLink:
    "https://wa.me/919591415859?text=Hello%20Keshavalal%20%26%20Company%2C%20we%20need%20a%20corporate%20umbrella%20quote.",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Nakshatra Umbrellas", path: "/nakshatra-umbrellas" },
  { label: "Corporate Branding", path: "/corporate-branding" },
  { label: "Manufacturing", path: "/manufacturing" },
  { label: "Past Clients", path: "/past-clients" },
  { label: "Contact", path: "/contact" },
];

export const nakshatraBrand = {
  name: "Nakshatra Umbrellas",
  description:
    "Nakshatra is our premium in-house umbrella brand known for durability, quality manufacturing and wide product range.",
  logo: logo,
  catalogLink: "https://wa.me/c/919591415859",
};

export const b2bStrengthPoints = [
  "We manufacture umbrellas at scale",
  "We supply wholesalers and distributors",
  "We provide custom printed umbrellas for corporate promotions",
];

export const trustIndicators = [
  { title: "4 Generations", detail: "Legacy-led umbrella production expertise" },
  { title: "Decades of Experience", detail: "Serving retail and corporate markets" },
  { title: "Large Client Base", detail: "Trusted by banks, dealers, and brands" },
  { title: "Bulk Capability", detail: "High-volume manufacturing and dispatch" },
];

export const services = [
  {
    title: "Umbrella Manufacturing",
    detail:
      "End-to-end umbrella production from raw material to packed finished goods.",
  },
  {
    title: "Our Brand Umbrellas",
    detail:
      "Reliable and durable branded umbrellas designed for wholesale and retail networks.",
  },
  {
    title: "Corporate Branding Umbrellas",
    detail:
      "Custom logo printed umbrellas for campaigns, dealership visibility, and gifting programs.",
  },
];

export const productCategories = [
  {
    slug: "folding-umbrellas",
    title: "Folding Umbrellas",
    image: foldingUmbrella
  },
  {
    slug: "long-umbrellas",
    title: "Long Umbrellas",
    image: longUmbrella
  },
  {
    slug: "golf-umbrellas",
    title: "Golf Umbrellas",
    image: golfUmbrella
  },
  {
    slug: "garden-umbrellas",
    title: "Garden Umbrellas",
    image: gardenUmbrella
  },
  {
    slug: "gazebos",
    title: "Gazebos",
    image: gazebos
  },
  {
    slug: "promotional-kiosks",
    title: "Promotional Kiosks",
    image: kiosk
  },
];

export const umbrellaProducts = [
  {
    slug: "folding",
    title: "Folding Umbrellas",
    description:
      "Compact and daily-use umbrella range made for retail distribution and corporate gifting.",
    gallery: [
      foldingUmbrella,
      foldingUmbrella1,
      foldingUmbrella2,
    ],
  },
  {
    slug: "long",
    title: "Long Umbrellas",
    description:
      "Classic long umbrella category with strong frame options and durable weather protection.",
    gallery: [
      long,
      long1,
      long2,
    ],
  },
  {
    slug: "golf",
    title: "Golf Umbrellas",
    description:
      "Large canopy umbrellas suitable for dealerships, hospitality, and premium promotions.",
    gallery: [
      golf,
      golf1,
      golf2,
    ],
  },
  {
    slug: "garden",
    title: "Garden Umbrellas",
    description:
      "Outdoor shade umbrellas for cafés, hotels, and open-air commercial spaces.",
    gallery: [
      garden,
      gardenUmbrella,
      garden1,
    ],
  },
  {
    slug: "kids",
    title: "Kids Umbrellas",
    description:
      "Colorful and lightweight umbrellas designed for children with safe handling and cheerful patterns.",
    gallery: [
      kids,
      kids1,
      kids2,
    ],
  },
  {
    slug: "gazebos",
    title: "Gazebos",
    description:
      "Branded gazebo structures built for outdoor activations, exhibitions, and campaign stalls.",
    gallery: [
      gazebos,
      gazebo1,
      gazebo2,
    ],
  },
];

export const corporateBrandingUseCases = [
  "Corporate promotions and employee gifting",
  "Automobile dealership branding campaigns",
  "Outdoor marketing and roadshow events",
  "Exhibitions and brand visibility activations",
];

export const manufacturingSteps = [
  {
    slug: "fabric-cutting",
    title: "Fabric Cutting",
    detail: "Precision cutting for canopy consistency across all umbrella types.",
  },
  {
    slug: "panel-stitching",
    title: "Panel Stitching",
    detail: "Strong seam stitching for durability and shape retention.",
  },
  {
    slug: "frame-assembly",
    title: "Frame Assembly",
    detail: "Manual and machine-assisted frame fitting for structural strength.",
  },
  {
    slug: "logo-printing",
    title: "Logo Printing",
    detail: "Custom branding and print alignment on selected canopy panels.",
  },
  {
    slug: "packaging",
    title: "Packaging",
    detail: "Bulk-ready packaging with custom requirements for dispatch.",
  },
  {
    slug: "dispatch",
    title: "Dispatch",
    detail: "Nationwide shipment coordination for wholesale and corporate orders.",
  },
];

export const clients = [
  "Bank of Baroda",
  "BSNL",
  "Adani",
  "Maruti Suzuki Distributors",
  "Ramco Cements",
  "Big Basket",
  "Hangyo Ice Creams",
  "Manipal Group",
];

export const caseStudies = [
  {
    title: "Bank Monsoon Awareness Campaign",
    summary: "Thousands of branded umbrellas distributed using head-office and branches.",
  },
  {
    title: "Automobile Dealership Visibility Program",
    summary: "Custom folding umbrellas supplied to dealer for city-wide free-service events.",
  },
  {
    title: "Cement Dealer Network Promotion",
    summary: "Bulk printed umbrellas dispatched across multiple states in phases.",
  },
];

export const clientLogoItems = [
  {
    id: "client-hangyo",
    logoUrl: hangyo,
    alt: "Client logo",
  },
  {
    id: "client-maruti",
    logoUrl: suzuki,
    alt: "Client logo",
  },
  {
    id: "client-bigbasket",
    logoUrl: bigbasket,
    alt: "Client logo",
  },
  {
    id: "client-ramco",
    logoUrl: ramco,
    alt: "Client logo",
  },
  {
    id: "client-manipal",
    logoUrl: manipal,
    alt: "Client logo",
  },
  {
    id: "client-bank-of-baroda",
    logoUrl: bob,
    alt: "Client logo",
  },
  {
    id: "client-adani",
    logoUrl: adani,
    alt: "Client logo",
  },
  {
    id: "client-bsnl",
    logoUrl: bsnl,
    alt: "Client logo",
  },
];

export const galleryItems = [
  {
    slug: "gallery-products",
    title: "Product Photos",
    image:
      "https://images.unsplash.com/photo-1580537272674-949686f4be5c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gallery-printed",
    title: "Printed Umbrellas",
    image:
      "https://images.unsplash.com/photo-1659006077432-64cef6df99ff?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gallery-factory",
    title: "Factory Visuals",
    image:
      "https://images.unsplash.com/photo-1758271452953-46f4e12ae2fd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gallery-packed",
    title: "Packed Orders",
    image:
      "https://images.unsplash.com/photo-1768796372539-24cde200bfef?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gallery-gazebo",
    title: "Gazebo Installations",
    image:
      "https://images.unsplash.com/photo-1764114903065-4cc137dd303b?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "gallery-branding",
    title: "Corporate Branding",
    image:
      "https://images.unsplash.com/photo-1764114908655-9a26d32750a0?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
  },
];

export const seoKeywords =
  "umbrella manufacturer India, custom printed umbrellas, corporate umbrellas, promotional umbrellas, branded umbrellas supplier";